// Use Netlify function for news API (no CORS issues)
const NEWS_API_BASE = window.location.hostname === 'localhost' 
  ? 'http://localhost:8888/.netlify/functions/news-api'
  : '/.netlify/functions/news-api';

export const fetchSportsNews = async (sport = 'NFL', count = 3) => {
  try {
    const response = await fetch(`${NEWS_API_BASE}?sport=${sport}&count=${count}`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.success && result.data) {
      return result.data;
    } else {
      throw new Error(result.error || 'Invalid response format');
    }
  } catch (error) {
    console.warn(`News API failed for ${sport}:`, error.message);
    return getMockNews(sport);
  }
};

// Fetch all sports news in one call (more efficient)
export const fetchAllSportsNews = async (count = 3) => {
  try {
    const response = await fetch(`${NEWS_API_BASE}?count=${count}`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.success && result.data) {
      return result.data;
    } else {
      throw new Error(result.error || 'Invalid response format');
    }
  } catch (error) {
    console.warn('All sports news API failed:', error.message);
    
    // Fallback: generate mock data for all sports
    const supportedSports = getSupportedSports();
    const allMockNews = [];
    
    supportedSports.forEach(sport => {
      const mockNews = getMockNews(sport).slice(0, count).map(item => ({
        ...item,
        sport
      }));
      allMockNews.push(...mockNews);
    });
    
    return allMockNews.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));
  }
};

// Mock data fallback
const getMockNews = (sport) => [
  {
    title: `${sport} Season Highlights - Breaking News`,
    link: '#',
    pubDate: new Date(),
    description: 'Stay updated with the latest highlights and breaking news from the world of sports.',
    source: 'Sports Network',
    guid: `mock-${sport}-1-${Date.now()}`
  },
  {
    title: `${sport} Player Analysis and Trade Updates`,
    link: '#',
    pubDate: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    description: 'In-depth analysis of recent player moves and team performance updates.',
    source: 'Sports Analytics',
    guid: `mock-${sport}-2-${Date.now()}`
  },
  {
    title: `${sport} Game Predictions and Betting Insights`,
    link: '#',
    pubDate: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 hours ago  
    description: 'Expert predictions and betting insights for upcoming games and matchups.',
    source: 'Betting Experts',
    guid: `mock-${sport}-3-${Date.now()}`
  }
];

export const getSupportedSports = () => ['NFL', 'MLB', 'NBA', 'WNBA', 'NHL', 'MLS', 'MMA'];
